import { render, staticRenderFns } from "./LandingPages.vue?vue&type=template&id=02b4ce88&scoped=true&"
import script from "./LandingPages.vue?vue&type=script&lang=js&"
export * from "./LandingPages.vue?vue&type=script&lang=js&"
import style0 from "./LandingPages.vue?vue&type=style&index=0&id=02b4ce88&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b4ce88",
  null
  
)

export default component.exports